


























import { Vue, Component } from 'vue-property-decorator'
import AddPromptDialog from '@/components/dialogs/AddPromptDialog.vue'
import ListSectionModel from '@/models/navigation/listSectionModel.ts'
import NavigationModel from '@/models/navigation/navigationModel.ts'
import SectionedListAdmin from '@/components/lists/SectionedListAdmin.vue'
import PromptModel from '../models/investigation/promptModel'
import apiService from '../services/apiService'
import { UrlType } from '../constants/urlType'
import { Dictionary } from 'vue-router/types/router'
import ExtensionModule from '../store/extensionModule'
import { getModule } from 'vuex-module-decorators'

const extensionModule = getModule(ExtensionModule)

@Component({
  components: {
    SectionedListAdmin,
    AddPromptDialog
  }
})
export default class PromptsAdmin extends Vue {
  private humanBehaviours: NavigationModel[] = []
  private esps: NavigationModel[] = []
  private organisation: NavigationModel[] = []

  private dialog: boolean = false

  private prompt: PromptModel = new PromptModel()

  private categories: Array<ListSectionModel<NavigationModel>> = [
    new ListSectionModel<NavigationModel>(
      'EQUIPMENT, SYSTEM OR PROCESS',
      this.esps
    ),
    new ListSectionModel<NavigationModel>(
      'HUMAN BEHAVIOUR',
      this.humanBehaviours
    ),
    new ListSectionModel<NavigationModel>('ORGANISATION', this.organisation)
  ]

  private async created() {
    this.subscribeToModalOpen()
    this.getPrompts()
  }

  private subscribeToModalOpen(): void {
    this.$root.$on('openNavbarModal', () => {
      this.dialog = true
    })
  }

  private navigate(item: NavigationModel) {
    this.$router.push({
      name: item.route,
      params: { id: item.params[0] }
    })
  }

  private async postPrompt(prompt: PromptModel): Promise<void> {
    const newPrompt = await apiService.post<PromptModel>(
      UrlType.ExtensionPrompt,
      prompt
    )
    let nav = new NavigationModel(newPrompt.prompt, 'edit-prompt', [
      newPrompt.extensionPromptId
    ])
    if (newPrompt.promptCategory == 'HB') {
      this.humanBehaviours.push(nav)
    } else if (newPrompt.promptCategory == 'ESP') {
      this.esps.push(nav)
    } else {
      this.organisation.push(nav)
    }
    this.dialog = false
  }

  private async getPrompts(): Promise<void> {
    const prompts = await apiService.getAll<PromptModel>(
      UrlType.ExtensionPromptByExtension + '/' + extensionModule.getExtensionId
    )

    const humanBehaviours = prompts.filter(x => x.promptCategory == 'HB')
    let humanBehaviourModels: NavigationModel[] = []

    humanBehaviours.forEach(function(item: PromptModel) {
      let nav = new NavigationModel(item.prompt, 'edit-prompt', [
        item.extensionPromptId
      ])
      humanBehaviourModels.push(nav)
    })

    this.humanBehaviours.push(...humanBehaviourModels)

    const esps = prompts.filter(x => x.promptCategory == 'ESP')
    let espModels: NavigationModel[] = []

    esps.forEach(function(item: PromptModel) {
      let nav = new NavigationModel(item.prompt, 'edit-prompt', [
        item.extensionPromptId
      ])
      espModels.push(nav)
    })

    this.esps.push(...espModels)

    const orgs = prompts.filter(x => x.promptCategory == 'ORG')
    let orgModels: NavigationModel[] = []

    orgs.forEach(function(item: PromptModel) {
      let nav = new NavigationModel(item.prompt, 'edit-prompt', [
        item.extensionPromptId
      ])
      orgModels.push(nav)
    })

    this.organisation.push(...orgModels)
  }
}
